/* ═══════════════════════════════════════════
   Status color/label maps — one source of truth
   ═══════════════════════════════════════════ */

import type { TaskStatus, PalletStatus, ShipmentStatus } from '@/types'

interface StatusMeta {
  label: string
  color: string          // Tailwind bg-* token
  textColor: string      // Tailwind text-* token
}

export const TASK_STATUS: Record<TaskStatus, StatusMeta> = {
  new:         { label: 'Новое',       color: 'bg-gray-100',   textColor: 'text-gray-700' },
  in_progress: { label: 'В работе',    color: 'bg-yellow-100', textColor: 'text-yellow-700' },
  completed:   { label: 'Завершено',   color: 'bg-green-100',  textColor: 'text-green-700' },
  shipped:     { label: 'Отгружено',   color: 'bg-indigo-100', textColor: 'text-indigo-700' },
}

export const PALLET_STATUS: Record<PalletStatus, StatusMeta> = {
  new:         { label: 'Новая',       color: 'bg-gray-100',   textColor: 'text-gray-700' },
  in_progress: { label: 'В работе',    color: 'bg-yellow-100', textColor: 'text-yellow-700' },
  completed:   { label: 'Завершена',   color: 'bg-green-100',  textColor: 'text-green-700' },
}

export const SHIPMENT_STATUS: Record<ShipmentStatus, StatusMeta> = {
  draft:     { label: 'Черновик',    color: 'bg-yellow-100', textColor: 'text-yellow-700' },
  completed: { label: 'Завершена',   color: 'bg-green-100',  textColor: 'text-green-700' },
}

/* ═══════════════════════════════════════════
   Nomenclature search modes
   ═══════════════════════════════════════════ */

/**
 * Режимы поиска номенклатуры — настраиваются как в 1С.
 *
 * substring  — вхождение подстроки (по умолчанию); ищет в названии И GTIN
 * starts_with — начало строки; ищет в названии или GTIN
 * gtin_only   — только по GTIN (точное вхождение)
 * name_only   — только по названию (вхождение подстроки)
 */
export type NomenclatureSearchMode = 'substring' | 'starts_with' | 'gtin_only' | 'name_only'

export const NOMENCLATURE_SEARCH_MODES: Record<NomenclatureSearchMode, string> = {
  substring:   'По подстроке (название + GTIN)',
  starts_with: 'С начала строки (название + GTIN)',
  gtin_only:   'Только по GTIN',
  name_only:   'Только по названию',
}

export const DEFAULT_NOMENCLATURE_SEARCH_MODE: NomenclatureSearchMode = 'substring'
